import React, { useState } from 'react';
import { TopBar } from '../components/TopBar';
import { WeeklyCommandSummary } from '../components/WeeklyCommandSummary';
import { ShiftContinuity } from '../components/ShiftContinuity';
import { FullBriefingModal } from '../components/FullBriefingModal';
import { data7Day, data14Day, data30Day, WeekData } from '../data/mockData';
const dataByRange: Record<string, WeekData> = {
  'Past 7 days': data7Day,
  'Past 14 days': data14Day,
  'Past 30 days': data30Day
};
export function Dashboard() {
  const [dateRange, setDateRange] = useState('Past 7 days');
  const [briefingOpen, setBriefingOpen] = useState(false);
  const activeData = dataByRange[dateRange] ?? data7Day;
  return <div style={{
    minHeight: '100vh',
    background: '#0d1421',
    fontFamily: 'Inter, system-ui, sans-serif'
  }} data-id="element-87">
      <TopBar dateRange={dateRange} onDateRangeChange={setDateRange} data-id="element-88" />

      <main style={{
      maxWidth: '1120px',
      margin: '0 auto',
      padding: '24px 16px 64px'
    }} data-id="element-89">
        <WeeklyCommandSummary onReadMore={() => setBriefingOpen(true)} commandSummaryCopy={activeData.commandSummaryCopy} data-id="element-90" />
        <div style={{
        height: '32px'
      }} data-id="element-91" />
        <ShiftContinuity passOnItems={activeData.passOnItems} shiftContinuityCopy={activeData.shiftContinuityCopy} data-id="element-92" />
      </main>

      <FullBriefingModal isOpen={briefingOpen} onClose={() => setBriefingOpen(false)} briefingCopy={activeData.briefingCopy} data-id="element-93" />
    </div>;
}